import { buildApiUrl } from './apiClient';

/** Bygger URL mot foto-proxyn. Returnerar null om photoRef saknas. */
export function photoUrl(photoRef: string | null | undefined, maxwidth = 800): string | null {
  if (!photoRef) return null;
  // v=2 ogiltigförklarar webbläsarnas vecko-cachade 302:or vars Google-bild-URL:er
  // hunnit dö (signerade, tidsbegränsade). Bumpa vid framtida cache-byten.
  return buildApiUrl('photo', { ref: photoRef, maxwidth: String(maxwidth), v: '2' });
}
